import { Injectable } from '@angular/core';
import { MsAdalAngular6Service } from 'microsoft-adal-angular6';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    constructor(private adalSvc: MsAdalAngular6Service) {
    }

    public logIn(): void {
        this.adalSvc.login();
    }
    public logOut(): void {
        this.adalSvc.logout();
    }
}
